import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: ${({ theme }) => theme.fontFamily.workSans};
        user-select: none;
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        -webkit-tap-highlight-color: transparent;
    }
    .app-route-components {
        position: relative;
        width: 100%;
        height: 100%;
    }
    html {
        scroll-behavior: smooth;
    }
    body {
        background: #fff;
    }
`;
export default GlobalStyles;
